import requests from "./httpService";

const LeadStatusServices = {
  getLeadStatuses(companyId) {
    return requests.get(`/lead-status/all?company_id=${companyId}`);
  },
  createLeadStatus(body) {
    return requests.post(`/lead-status/create`, body);
  },
  updateLeadStatus(id, body) {
    return requests.post(`/lead-status/update/${id}`, body);
  },
  deleteLeadStatus(id) {
    return requests.delete(`/lead-status/${id}`);
  },
  statusChange(id) {
    return requests.post(`/lead-status/statusupdate/${id}`);
  },
  getDetail(id) {
    return requests.get(`/lead-status/${id}`);
  }
};

export default LeadStatusServices;
